import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Hero from './components/Hero';
import Benefits from './components/Benefits';
import PincodeChecker from './components/PincodeChecker';
import Subscription from './components/Subscription';
import SamplePack from './components/SamplePack';
import Varieties from './components/Varieties';
import Cart from './components/Cart';
import HowItWorks from './components/HowItWorks';
import Testimonials from './components/Testimonials';
import About from './components/About';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import VerifyEmail from './pages/VerifyEmail';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import TermsConditions from './pages/TermsConditions';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import ShippingDelivery from './pages/ShippingDelivery';
import CancellationRefund from './pages/CancellationRefund';
import AboutPage from './pages/AboutPage';
import Checkout from './pages/Checkout';
import BlogList from './pages/blog/BlogList';
import BlogPost from './pages/blog/BlogPost';
import AdminDashboard from './pages/admin/AdminDashboard';
import ProductsManagement from './pages/admin/ProductsManagement';
import OrdersManagement from './pages/admin/OrdersManagement';
import SubscriptionsManagement from './pages/admin/SubscriptionsManagement';
import UsersManagement from './pages/admin/UsersManagement';
import PincodeManagement from './pages/admin/PincodeManagement';
import DebugUser from './pages/DebugUser';

// HomePage component moved outside to fix React warning
const HomePage = () => (
  <>
    <Hero />
    <Benefits />
    <PincodeChecker />
    <Subscription />
    <SamplePack />
    <Varieties />
    <HowItWorks />
    <Testimonials />
    <About />
    <FAQ />
    <Contact />
  </>
);

function App() {
  const [isCartOpen, setIsCartOpen] = React.useState(false);

  const handleCartClick = () => {
    setIsCartOpen(true);
  };

  const handleCartClose = () => {
    setIsCartOpen(false);
  };

  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <ScrollToTop />
          <div className="App">
            <Routes>
              {/* Auth Routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password/:token" element={<ResetPassword />} />
              <Route path="/debug-user" element={<DebugUser />} />
              
              {/* Dashboard Routes - Protected */}
              <Route path="/dashboard/*" element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } />

              {/* Admin Routes - Require Admin Role */}
              <Route path="/admin" element={
                <ProtectedRoute requireAdmin={true}>
                  <AdminDashboard />
                </ProtectedRoute>
              } />
              <Route path="/admin/products" element={
                <ProtectedRoute requireAdmin={true}>
                  <ProductsManagement />
                </ProtectedRoute>
              } />
              <Route path="/admin/orders" element={
                <ProtectedRoute requireAdmin={true}>
                  <OrdersManagement />
                </ProtectedRoute>
              } />
              <Route path="/admin/subscriptions" element={
                <ProtectedRoute requireAdmin={true}>
                  <SubscriptionsManagement />
                </ProtectedRoute>
              } />
              <Route path="/admin/users" element={
                <ProtectedRoute requireAdmin={true}>
                  <UsersManagement />
                </ProtectedRoute>
              } />
              <Route path="/admin/pincodes" element={
                <ProtectedRoute requireAdmin={true}>
                  <PincodeManagement />
                </ProtectedRoute>
              } />
              
              {/* Public Routes with Header/Footer */}
              <Route path="/*" element={
                <>
                  <Header onCartClick={handleCartClick} />
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/terms-conditions" element={<TermsConditions />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                    <Route path="/shipping-delivery" element={<ShippingDelivery />} />
                    <Route path="/cancellation-refund" element={<CancellationRefund />} />
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/checkout" element={<Checkout />} />
                    <Route path="/blog" element={<BlogList />} />
                    <Route path="/blog/:slug" element={<BlogPost />} />
                  </Routes>
                  <Footer />
                  {isCartOpen && <Cart onClose={handleCartClose} />}
                </>
              } />
            </Routes>
          </div>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;